import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Row, Col, Button, Form, Input, Select, Checkbox } from 'antd';
import styles from '../css/create.module.css';
import logoWeibo from '../assets/desktop_live_ic_weibo@2x.png';

const FormItem = Form.Item;
const Option = Select.Option;

const resolutions = {
  '4K': {
    width: '3840',
    height: '2160',
  },
  '4KL': {
    width: '3840',
    height: '1920',
  },
  '3K': {
    width: '2880',
    height: '1440',
  },
  '2K': {
    width: '1920',
    height: '1080',
  },
  '2KL': {
    width: '1920',
    height: '960',
  },
  '720P': {
    width: '1440',
    height: '720',
  },
};
const resolution = [
  { key: '4K 3840*1920', value: '4KL' },
  { key: '4K 3840*2160', value: '4K' },
  { key: '3K 2880*1440', value: '3K' },
  { key: '2K 1920*1080', value: '2K' },
  { key: '2K 1920*960', value: '2KL' },
  { key: '720P 1440*720', value: '720P' },
];
const published = [{ key: 'live_weibo_create_form_privacy_public', value: '0' }, { key: 'live_weibo_create_form_privacy_private', value: '1' }];

@inject('app', 'weibo')
@observer
class CreateForm extends Component {
  state = {
    customImage: false,
    submitLock: false
  };

  onCheckImage = e => {
    this.setState({
      customImage: e.target.checked,
    });
  };

  handleCreate = () => {
    const form = this.props.form;
    const { weibo, app } = this.props;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const { title, summary, published, resolution, image } = values;
      const size = resolutions[resolution];
      const options = {
        ...size,
        title,
        image,
        summary,
        published,
      };
      // console.log('Received values of form: ', options)
      
      this.setState({submitLock: true});
      weibo.create(options, {
        success: () => {
          this.setState({submitLock: false});

          form.resetFields();
          app.routePush('/live/weibo');
        },
        fail: () => {
          this.setState({submitLock: false});
        }
      });
    });
  };

  render() {
    const { form, app } = this.props;
    const { getFieldDecorator } = form;
    const { langs } = app;
    return (
      <Form style={{marginTop: '16px'}} layout="vertical">
          <FormItem label={langs['live_fb_create_form_title_label']}>
            {getFieldDecorator('title', {
              rules: [{ required: true }],
              initialValue: langs['live_fb_create_form_title_initial_value'],
            })(<Input />)}
          </FormItem>
          <FormItem label={langs['live_fb_create_form_desc_label']}>
            {getFieldDecorator('summary', {
              rules: [{ required: true }],
              initialValue: langs['live_fb_create_form_desc_initial_value'],
            })(<Input type="textarea" />)}
          </FormItem>
          <FormItem label={langs['live_weibo_create_form_resolution']}>
            {getFieldDecorator('resolution', {
              initialValue: '4K',
            })(
              <Select>
                {resolution.map((p, i) => {
                  const { key, value } = p;
                  return (
                    <Option key={i} value={value}>
                      {key}
                    </Option>
                  );
                })}
              </Select>
            )}
          </FormItem>
          <FormItem label={langs['live_weibo_create_form_cover']}>
            <Checkbox onChange={this.onCheckImage}>
              {langs['live_weibo_create_form_custom_cover']}
            </Checkbox>
            {getFieldDecorator('image', {
              rules: [
                {
                  type: 'url'
                },
              ],
              initialValue:
                'https://static.insta360.com/assets/operation/0007/53fb5fb861ad87680afcbb097ed2eee9/pro_weibo_cover_1920.png',
            })(<Input disabled={!this.state.customImage} />)}
          </FormItem>
          <FormItem label={langs['live_weibo_create_form_privacy']}>
            {getFieldDecorator('published', {
              initialValue: '0',
            })(
              <Select>
                {published.map((p, i) => {
                  const { key, value } = p;
                  return (
                    <Option key={i} value={value}>
                      {langs[key]}
                    </Option>
                  );
                })}
              </Select>
            )}
            <p
              style={{
                color: 'red',
                lineHeight: '20px',
                fontSize: '10px',
                marginTop: '1em',
              }}
            >
              {langs['live_weibo_create_form_privacy_note']}
            </p>
          </FormItem>

          <Button
            type="primary"
            loading={this.state.submitLock}
            onClick={this.handleCreate}
          >
            {langs["live_create"]}
          </Button>
        </Form>
    )
  }
} 
const CollectionCreateForm = Form.create()(CreateForm);

@inject('app', 'weibo')
@observer
export default class Create extends Component {
  componentDidMount() {
    const { app, weibo } = this.props;
    app.setBreadcrumbs(['live', 'weibo_streams', 'weibo_create'], 'weibo');

    if (!weibo.accessToken) {
      app.routePush('/live/weibo');
    }
  }

  render() {
    const { langs } = this.props.app

    return (
      <div className={styles.content}>
        <Row gutter={16}>
          <Col xs={24} md={6}>
            <img src={logoWeibo} className={styles.logo}></img>
          </Col>
          <Col xs={24} md={18}>
            <CollectionCreateForm />
          </Col>
        </Row>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/live/weibo/create.js